import { baseStudio } from './baseUrl';

export const positionalAudiosPack = [
  {
    name: `Ocean Waves`,
    url: `${baseStudio}mp3Audio/audio1.mp3`,
  },
  {
    name: `Rain Sound`,
    url: `${baseStudio}mp3Audio/audio2.mp3`,
  },
  {
    name: `Relaxation Music`,
    url: `${baseStudio}mp3Audio/audio3.mp3`,
  },
  {
    name: `Nature Sounds`,
    url: `${baseStudio}mp3Audio/audio4.mp3`,
  },
  {
    name: `Bird Songs`,
    url: `${baseStudio}mp3Audio/audio5.mp3`,
  },
  {
    name: `River Flow`,
    url: `${baseStudio}mp3Audio/audio6.mp3`,
  },
  {
    name: `Relaxation Music`,
    url: `${baseStudio}mp3Audio/audio7.mp3`,
  },
  {
    name: `Music`,
    url: `${baseStudio}mp3Audio/audio8.mp3`,
  },
];
